const ShopSuey = {
  noScroll(active = true) {
    const body = document.querySelector("body");

    if (active) {
      this._scrollPosition = window.scrollY;
      body.classList.add("no-scroll");
      body.style.top = `-${this._scrollPosition}px`;
    } else {
      body.classList.remove("no-scroll");
      body.style.top = "";

      if (this._scrollPosition !== undefined) {
        window.scrollTo(0, this._scrollPosition);
        this._scrollPosition = undefined;
      }
    }
  },
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`
      }
    };
  },
  getSectionInnerHTML(html, selector = null) {
    if (!html) return "";

    try {
      const parsed = new DOMParser().parseFromString(html, "text/html");

      if (!selector) {
        return parsed.body.innerHTML;
      }

      const selectors = [selector, `[x-ref="${selector}"]`, `#${selector}`, `.${selector}`];

      for (const sel of selectors) {
        const element = parsed.querySelector(sel);
        if (element) {
          return element.innerHTML;
        }
      }

      return html;
    } catch (error) {
      console.warn("Error parsing section HTML:", error);
      return html;
    }
  },

  updateSections(data, context) {
    if (!data?.sections) return;

    const sections = Array.isArray(data.sections)
      ? data.sections.reduce((acc, section) => {
          acc[section] = data.sections[section];
          return acc;
        }, {})
      : data.sections;

    Object.entries(sections).forEach(([section, content]) => {
      const sectionRef = context?.$refs?.[section];
      if (sectionRef) {
        const newContent = this.getSectionInnerHTML(content, section);
        if (newContent) {
          sectionRef.firstElementChild.innerHTML = newContent;
        }
      }
    });
  },
  setCSSVariable(variable, value) {
    document.documentElement.style.setProperty(variable, value);
  },
  getCSSVariable(variable) {
    getComputedStyle(document.documentElement).getPropertyValue(variable);
  },

  cart: {
    async update({ url, body = {}, context, onSuccess, onError }) {
      try {
        let config = {
          method: "POST"
        };

        if (body instanceof FormData) {
          config.body = body;

          if (!body.has("sections")) {
            const sections = ShopSuey.cart.getDefaultSections();
            body.append("sections", sections.join(","));
          }

          config.headers = {
            Accept: "application/json"
          };
        } else {
          config = {
            ...config,
            ...ShopSuey.fetchConfig(),
            body: typeof body === "string" ? body : JSON.stringify(body)
          };
        }

        const response = await fetch(url, config);
        const data = await response.json();

        // Special handling for 422 responses (inventory limits)
        if (response.status === 422) {
          return {
            errors: data.errors || data.description || "Inventory limit reached",
            status: 422,
            ...data
          };
        }

        if (!response.ok) {
          // If we have errors in the response, return them in a structured way
          if (data.errors || (typeof data === "object" && Object.keys(data).length > 0)) {
            return {
              errors: data.errors || data.description || data.message || "An error occurred",
              status: response.status,
              ...data
            };
          }
          throw new Error("Cart update failed");
        }

        // Only check token for cart modification operations (not .js endpoints and not /cart/add)
        if (url.includes("/cart/") && !url.endsWith(".js") && !url.endsWith("/add")) {
          if (!data.token) {
            throw new Error("Cart update failed");
          }
        }

        // Update sections if they exist in the response
        if (data.sections && context) {
          ShopSuey.updateSections(data, context);
        }

        if (onSuccess) {
          onSuccess(data);
        }

        return data;
      } catch (error) {
        console.error("Error updating cart:", error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    },
    getDefaultSections() {
      return ["cart-icon-bubble", "cart-footer", "cart-items"];
    },
    createTimeout(callback, delay = 3000) {
      const timeoutId = setTimeout(() => {
        callback();
      }, delay);
      return timeoutId;
    },
    clearTimeout(timeoutId) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  },

  translations: {
    _translations: null,
    _ready: false,
    _waitForTranslations() {
      return new Promise((resolve) => {
        if (this._ready) {
          resolve();
          return;
        }

        const checkTranslations = () => {
          if (window.theme?.translations) {
            this._translations = window.theme.translations;
            this._ready = true;
            resolve();
          } else {
            setTimeout(checkTranslations, 50);
          }
        };

        checkTranslations();
      });
    },
    async t(key) {
      await this._waitForTranslations();

      const parts = key.split(".");
      let value = this._translations;

      for (const part of parts) {
        value = value?.[part];
        if (value === undefined) {
          console.warn(`Translation key not found: ${key}`);
          return key;
        }
      }

      return value;
    }
  }
};

ShopSuey.translations._waitForTranslations();

// Make ShopSuey available globally
window.ShopSuey = ShopSuey;

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
}
